import React from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Separator,
  Button,
} from '@lb-classroom/ui';
import { X } from 'lucide-react';
import Textarea from '@components/UI/atoms/form/Textarea';
import RadioInputs from '@components/UI/atoms/form/RadioInputs';
import ModalMessage from '@components/UI/organisms/ModalMessage';
import type { TutorCancelBookingModalProps } from './tutor-cancel-booking-modal.types';

export const TutorCancelBookingModal = ({
  selectedReason,
  comment,
  reasonOptions,
  isSubmitting,
  message,
  messageType,
  onReasonChange,
  onCommentChange,
  onSubmit,
  onCancel,
}: TutorCancelBookingModalProps) => {
  const reasonSelectProps = {
    options: reasonOptions,
    className: '',
    id: 'edit-proficiency',
    value: selectedReason,
    name: 'issue-type',
    updateHandler: onReasonChange,
    invalidLabel: true,
    onKeyDown: onSubmit,
  };

  const commentProps = {
    rows: 5,
    value: comment,
    updateHandler: onCommentChange,
    className:
      'max-w-lg shadow-sm block w-full sm:text-sm border border-light-gray rounded-md py-2 px-4',
  };

  return (
    <div className="max-w-md mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>Cancel Booking</CardTitle>
          <button type="button" className="modal-close" onClick={onCancel}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <ModalMessage message={message} messageType={messageType} />
          <form
            method="put"
            className="report-issue-form cancel-booking-by-tutor-form"
            onSubmit={onSubmit}
            noValidate
          >
            <div>
              <div className="reasons-wrapper">
                <h5>Select a reason.</h5>
                <p>
                  {"Select 'Cancel on behalf of student' only if the student asked you to cancel the booking."}
                </p>
                <RadioInputs {...reasonSelectProps} />
              </div>
              <div className="message-wrapper mt-8">
                <h5 className="mb-8">Message to the student</h5>
                <Textarea {...commentProps} />
                <p>
                  Please write the details of the reason and apology message for
                  your student. For tracking purpose, both the student and
                  LingualBox staff will be notified of the reason.
                </p>
              </div>
            </div>
            <Separator className="my-4" />
            <div className="text-right">
              <Button size="lg" disabled={isSubmitting} onClick={onSubmit}>
                Submit
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
